import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ChipV3Component, ColumnDefinitionV3 } from '@gea/digital-ui-lib';
import { TooltipModule } from 'primeng/tooltip';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'hrt-filter-chips',
  templateUrl: './hrt-filter-chips.component.html',
  styleUrls: ['./hrt-filter-chips.component.scss'],
  standalone: true,
  imports: [TooltipModule, ChipV3Component, TableModule],
})
export class HrtFilterChipsComponent {
  @Input() columnDefinitions?: ColumnDefinitionV3[] = [];
  @Input() activeChipFilters?: ActiveChipFilters;
  @Input() globalSearch?: string;
  @Input() tableId?: string;
  @Output() chipRemoved = new EventEmitter<any>();

  getFilterKeys(): string[] {
    return this.activeChipFilters?.filters
      ? Object.keys(this.activeChipFilters.filters)
      : [];
  }

  getChipFilterName(key: string): string {
    const column = this.columnDefinitions?.find((col) => col.key === key);
    return column ? column.displayName : key;
  }

  getChipDisplayValueName(key: string, value: string): string {
    const column = this.columnDefinitions?.find((col) => col.key === key);
    const filter = column?.filter;
    // Only SelectFilterRendererV3 has config
    if (filter && 'config' in filter && filter.config?.options) {
      const options = filter.config.options;
      const found = options.find((opt: any) => opt.value === value);
      return found ? found.name : value;
    }
    return value;
  }

  getFilterValues(val: string): any[] {
    return this.activeChipFilters?.filters[val]?.filter || [];
  }

  getFilterChipCount(): number {
    let count = 0;
    if (this.activeChipFilters?.searchText) {
      count += 1;
    }
    if (this.activeChipFilters?.filters) {
      for (const key of Object.keys(this.activeChipFilters.filters)) {
        const filterArr = this.activeChipFilters.filters[key]?.filter;
        if (Array.isArray(filterArr)) {
          count += filterArr.length;
        }
        if (
          this.activeChipFilters.filters[key]?.sort &&
          this.activeChipFilters.filters[key].sort !== ''
        ) {
          count += 1;
        }
      }
    }
    return count;
  }

  removeChip(chip: Chip) {
    this.chipRemoved.emit(chip);
  }
}

export interface ActiveChipFilters {
  searchText?: string;
  filters?: any;
}

export interface Chip {
  chipKey: any;
  chipValue: any;
}
